// extracted by mini-css-extract-plugin
module.exports = {"nextiaWraper":"styles_nextiaWraper__1P6Z1","nextiaMeet":"styles_nextiaMeet__2I3qo","descriptionWrapper":"styles_descriptionWrapper__2_49m"};